document.addEventListener('alpine:init', function () {
    Alpine.data('textBanner', function () {
        var MYDOORS_SHARE_PATH = '/my-doors?title={title}&products={products}';
        return {
            modalOpen: false,
            copied: false,
            collectionTitle: '',
            copyURL: function () {
                var _this = this;
                var encodedTitle = encodeURIComponent(this.collectionTitle);
                var encodedProducts = encodeURIComponent(this.$store.doors.get(true));
                var pathname = MYDOORS_SHARE_PATH.replace('{title}', encodedTitle).replace('{products}', encodedProducts);
                navigator.clipboard
                    .writeText(window.location.origin + pathname)
                    .then(function () {
                    _this.copied = true;
                    // setTimeout(() => {
                    //   this.closeModal();
                    // }, 3000);
                })
                    .catch(console.error);
            },
            openModal: function () {
                var _this = this;
                this.copied = false;
                this.modalOpen = true;
                setTimeout(function () {
                    _this.$refs.collectionTitleInput.focus();
                }, 500);
            },
            closeModal: function () {
                this.modalOpen = false;
            },
        };
    });
});
